<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Fusionner</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <app-folder-selector [ignoredFolders]="data.sourceFolders" (folderSelected)="onSelected($event)"></app-folder-selector>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        <button mat-raised-button class="accent-button" [mat-dialog-close]="data" [disabled]="!data.targetFolder">Valider</button>
    </mat-card-actions>
</mat-card>
